import axios from "axios";
// Get base URL from .env file
const baseUrl = process.env.REACT_APP_API_URL;

export const publishBlog = async (blogId, isPublished) => {
  try {
    // You can send data as JSON.
    const response = await axios.post(
      `${baseUrl}/api/Coltec/PublishBlog`,
      { blogId, isPublished },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    // Optionally, handle error logging or user notifications here.
    throw error;
  }
};
